import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff7df84a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-cols-3" }
const _hoisted_2 = { class: "row-cols-2" }
const _hoisted_3 = { class: "row-cols-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass('no-wrap')
}
const _hoisted_6 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass('no-wrap')
}
const _hoisted_7 = {
  class: /*#__PURE__*/_normalizeClass('no-wrap')
}
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormFieldMultiSelect = _resolveComponent("FormFieldMultiSelect")!
  const _component_AdvancedSearch = _resolveComponent("AdvancedSearch")!
  const _component_priority_block = _resolveComponent("priority-block")!
  const _component_ContentCopyIcon = _resolveComponent("ContentCopyIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_OpenInBrowserIcon = _resolveComponent("OpenInBrowserIcon")!
  const _component_EditIcon = _resolveComponent("EditIcon")!
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, {
    title: "Товары",
    "header-buttons": [
      {
        text: 'Новый товар',
        href: _ctx.getProductFormUrl({ productId: 'create' }),
      },
    ]
  }, {
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        "column-defs": _ctx.columnDefs,
        "row-data": _ctx.rowData,
        loading: _ctx.isRowDataLoading,
        "error-message": _ctx.errorMessage,
        "search-query": _ctx.searchQuery,
        pagination: {
          pageNumber: _ctx.pageNumber,
          pageCount: _ctx.pageCount,
          pageSize: _ctx.pageSize,
          disabled: _ctx.isRowDataLoading,
        },
        onChange: _ctx.handleChange
      }, {
        filters: _withCtx(() => [
          _createVNode(_component_AdvancedSearch, {
            tags: _ctx.tags,
            "onClick:tag": _ctx.handleTagRemove
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_FormFieldMultiSelect, {
                  "selected-options": _ctx.productTypeFilter,
                  "onUpdate:selected-options": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productTypeFilter) = $event)),
                  options: _ctx.productTypeOptionList,
                  name: "productTypeFilter",
                  label: "Тип товара",
                  class: "filter",
                  searchable: true
                }, null, 8, ["selected-options", "options"]),
                _createVNode(_component_FormFieldMultiSelect, {
                  "selected-options": _ctx.categoryFilter,
                  "onUpdate:selected-options": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.categoryFilter) = $event)),
                  options: _ctx.categoryOptionList,
                  name: "categoryFilter",
                  label: "Категория",
                  class: "filter",
                  searchable: true
                }, null, 8, ["selected-options", "options"]),
                _createVNode(_component_FormFieldMultiSelect, {
                  "selected-options": _ctx.availabilityFilter,
                  "onUpdate:selected-options": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.availabilityFilter) = $event)),
                  options: _ctx.availabilityOptionList,
                  name: "availabilityFilter",
                  label: "Статус",
                  class: "filter",
                  searchable: true
                }, null, 8, ["selected-options", "options"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_FormFieldMultiSelect, {
                  "selected-options": _ctx.brandFilter,
                  "onUpdate:selected-options": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.brandFilter) = $event)),
                  options: _ctx.brandOptionList,
                  name: "brandFilter",
                  label: "Бренд",
                  class: "filter",
                  searchable: true
                }, null, 8, ["selected-options", "options"]),
                _createVNode(_component_FormFieldMultiSelect, {
                  "selected-options": _ctx.specialFilter,
                  "onUpdate:selected-options": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.specialFilter) = $event)),
                  options: _ctx.specialOptionList,
                  name: "specialFilter",
                  label: "Спецпредложения",
                  class: "filter",
                  searchable: true
                }, null, 8, ["selected-options", "options"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_FormFieldMultiSelect, {
                  "selected-options": _ctx.productGroupFilter,
                  "onUpdate:selected-options": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productGroupFilter) = $event)),
                  options: _ctx.productGroupOptionList,
                  name: "productGroupFilter",
                  label: "Группы товаров",
                  class: "filter",
                  searchable: true
                }, null, 8, ["selected-options", "options"]),
                _createVNode(_component_FormFieldMultiSelect, {
                  "selected-options": _ctx.collectionFilter,
                  "onUpdate:selected-options": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.collectionFilter) = $event)),
                  options: _ctx.collectionOptionList,
                  name: "collectionFilter",
                  label: "Коллекции",
                  class: "filter",
                  searchable: true
                }, null, 8, ["selected-options", "options"])
              ])
            ]),
            _: 1
          }, 8, ["tags", "onClick:tag"])
        ]),
        "cell(priority)": _withCtx(({ row }) => [
          _createVNode(_component_priority_block, {
            id: row.id,
            priority: String(row.priority)
          }, null, 8, ["id", "priority"])
        ]),
        "cell(price)": _withCtx(({ row }) => [
          (!row.multiplePriceCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (row.price)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("span", {
                        class: _normalizeClass(row.discountPrice ? 'old-price' : null)
                      }, _toDisplayString(row.price) + " руб ", 3)
                    ]))
                  : _createCommentVNode("", true),
                (row.discountPrice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(row.discountPrice) + " руб", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", null, _toDisplayString(row.discountPrice
                  ? `от ${row.discountPrice} руб`
                  : `от ${row.price} руб`), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.getLabelVacancies(row.multiplePriceCount)), 1)
              ]))
        ]),
        "cell(availability)": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_ctx.getAvailabilityLabel(
              row.availability,
              row.waitingDays,
              row.availableQuantity
            )), 1)
        ]),
        "cell(actions)": _withCtx(({ row }) => [
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Клонировать",
            disabled: _ctx.isBusy(row.id),
            onClick: ($event: any) => (_ctx.handleResourceClone(row.id))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ContentCopyIcon)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]),
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Просмотреть на сайте",
            href: row.url,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_OpenInBrowserIcon)
            ]),
            _: 2
          }, 1032, ["href"]),
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Редактировать товар",
            disabled: _ctx.isBusy(row.id),
            href: _ctx.getProductFormUrl({ productId: row.id })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_EditIcon)
            ]),
            _: 2
          }, 1032, ["disabled", "href"]),
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Удалить товар",
            disabled: _ctx.isBusy(row.id),
            onClick: ($event: any) => (_ctx.handleProductDelete(row.id))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DeleteIcon)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ]),
        _: 1
      }, 8, ["column-defs", "row-data", "loading", "error-message", "search-query", "pagination", "onChange"])
    ]),
    _: 1
  }, 8, ["header-buttons"]))
}